import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimDecimal',
  standalone: false,
})
export class TrimDecimalPipe implements PipeTransform {
  /**
   * @description Checks if value is string, '0', or ''. Otherwise, checks if value is more than
   * 2 decimal places, if it is, sets it to "decimalPlaces" value of decimal points.
   * @example trimDecimal: 2 //20.0500412 = 20.05
   * @example trimDecimal: 3 //20.0500412 = 20.050
   * @example trimDecimal: 2 //'20.00000000' = 20.00
   */
  public transform<T = string | number>(value: T, decimalPlaces: number): number {
    const numericValue = Number(value);

    if (this.countDecimals(numericValue) <= 2) return numericValue;
    else return Number(numericValue.toFixed(decimalPlaces));
  }

  private countDecimals(value: number): number {
    if (Math.floor(value) === value) return 0;
    return value.toString().split('.')[1].length || 0;
  }
}
